import { type GaiaWebSocketResponse, gaiaWsEventBus } from "@expert/gaia";
import type { CallTranscriptMessage, TranscriptSnippet } from "@expert/shared-types";
import { useEffect } from "react";
import { getRootDispatcher } from "@/analytics";
import { mergeSnippets } from "@/transcript/utils/mergeSnippets";

const TRANSCRIPT_SNIPPET_LOG_INTERVAL = 10000;

export const useTranscriptSnippetListener = (
    setSnippets: (value: React.SetStateAction<TranscriptSnippet[] | undefined>) => void,
) => {
    // biome-ignore lint/correctness/useExhaustiveDependencies: fix later
    useEffect(() => {
        const subscription = gaiaWsEventBus.on("gaia_ws_call-transcript", ({ body }: GaiaWebSocketResponse) => {
            const { transcripts, timestamp: gaiaTimestamp } = body as CallTranscriptMessage;
            if (transcripts) {
                const exwoTimestamp = Date.now();

                transcripts.forEach((t) => {
                    const shouldSend = Math.floor(Math.random() * TRANSCRIPT_SNIPPET_LOG_INTERVAL) + 1 === 1;
                    if (shouldSend) {
                        void getRootDispatcher().dispatchBusinessEvent("TranscriptSnippetReceived", {
                            gaiaTimestamp,
                            exwoTimestamp: exwoTimestamp,
                            snippetTimestamp: t.timestamp,
                        });
                    }
                });
                setSnippets((prevState) => mergeSnippets(prevState, transcripts));
            }
        });
        return () => subscription();
    }, []);
};
